/* =====================================================================
   BOATMAT QUOTE ARTWORK UPLOADS — shared enhancer (2026-10-27).

   One asset gives every BoatMat quote entry point a real multi-file
   artwork upload: the Custom Size Quote modals on the HD Yacht Mat,
   Embroidered Deck, Sunbrella Boarding and Protective Luggage stations
   (auto-mounted into #csqForm), and the Contact/Quote form section
   (mounted explicitly via window.bmQuoteArt.mount).

   Files upload to BMOS's existing quote-artwork endpoint
   (/public/web-intake/quote-artwork — validated, size-capped, stored
   under an unguessable id) AT SUBMIT TIME, sequentially, so an abandoned
   form never leaves orphaned uploads. The station/form submit code calls
   uploadAll() first and attaches list() to its payload as `artworks`.
   Upload is OPTIONAL — an empty queue resolves immediately.
   ===================================================================== */
(function () {
  'use strict';
  if (window.bmQuoteArt) return;

  var ENDPOINT = 'https://admin.boatmat.com/public/web-intake/quote-artwork';
  var MAX_FILES = 8;
  var MAX_BYTES = 16 * 1024 * 1024; /* matches the server's limit */
  var EXT_RE = /\.(png|jpe?g|gif|webp|svg|pdf|ai|eps|tiff?)$/i;
  var ACCEPT = '.png,.jpg,.jpeg,.gif,.webp,.svg,.pdf,.ai,.eps,.tif,.tiff';

  /* queue entries: { file, name, status: 'pending'|'uploading'|'done'|'error', url } */
  var queues = []; /* one queue per mounted widget */

  function h(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text) e.textContent = text;
    return e;
  }

  function renderList(q) {
    q.listEl.innerHTML = '';
    q.items.forEach(function (it, i) {
      var row = h('div', 'bmqa-file');
      var nm = h('span', 'bmqa-name', it.name);
      var st = h('span', 'bmqa-st ' + it.status,
        it.status === 'done' ? '✓ uploaded' :
        it.status === 'uploading' ? 'uploading…' :
        it.status === 'error' ? (it.err || 'upload failed') : 'ready to send');
      var rm = h('button', 'bmqa-rm', 'Remove');
      rm.type = 'button';
      rm.setAttribute('aria-label', 'Remove ' + it.name);
      rm.onclick = function () { q.items.splice(i, 1); renderList(q); syncMsg(q, ''); };
      row.appendChild(nm); row.appendChild(st); row.appendChild(rm);
      q.listEl.appendChild(row);
    });
    q.listEl.hidden = q.items.length === 0;
  }

  function syncMsg(q, text, isErr) {
    q.msgEl.textContent = text || '';
    q.msgEl.hidden = !text;
    q.msgEl.classList.toggle('err', !!isErr);
  }

  function addFiles(q, files) {
    var added = 0;
    for (var i = 0; i < files.length; i++) {
      var f = files[i];
      if (q.items.length >= MAX_FILES) { syncMsg(q, 'Up to ' + MAX_FILES + ' files per request — remove one to add another.', true); break; }
      if (!EXT_RE.test(f.name)) { syncMsg(q, '"' + f.name + '" is not a supported file type. Accepted: JPG, PNG, GIF, WEBP, SVG, PDF, AI, EPS, TIFF.', true); continue; }
      if (f.size > MAX_BYTES) { syncMsg(q, '"' + f.name + '" is larger than 16 MB — please send a smaller file or mention it in the notes and we will follow up.', true); continue; }
      q.items.push({ file: f, name: f.name, status: 'pending', url: null });
      added++;
    }
    if (added) syncMsg(q, '');
    renderList(q);
  }

  function uploadOne(it, cb) {
    if (it.status === 'done' && it.url) { cb(true); return; }
    if (!window.FileReader || !window.fetch) { it.status = 'error'; it.err = 'browser not supported'; cb(false); return; }
    it.status = 'uploading';
    var fr = new FileReader();
    fr.onload = function () {
      fetch(ENDPOINT, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ filename: it.name, data: String(fr.result) })
      }).then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
        .then(function (j) {
          if (j && j.ok && j.url) { it.status = 'done'; it.url = j.url; cb(true); }
          else { it.status = 'error'; it.err = (j && j.error) || 'upload failed'; cb(false); }
        })
        .catch(function () { it.status = 'error'; it.err = 'network error'; cb(false); });
    };
    fr.onerror = function () { it.status = 'error'; it.err = 'could not read file'; cb(false); };
    fr.readAsDataURL(it.file);
  }

  function mount(container, beforeEl) {
    if (!container || container.querySelector('.bmqa')) return null;
    var q = { items: [] };
    var box = h('div', 'bmqa');
    var lbl = h('div', 'bmqa-lbl', 'Upload Your Artwork or Reference Images');
    var sub = h('p', 'bmqa-sub', 'Please attach your logo, artwork, photograph, sketch, or reference image so we can better understand your project. Preliminary artwork is fine.');
    var sub2 = h('p', 'bmqa-sub2', 'You may upload multiple files (up to ' + MAX_FILES + ', 16 MB each — JPG, PNG, GIF, WEBP, SVG, PDF, AI, EPS, TIFF). Artwork is helpful for preparing an accurate quotation but is not required to submit your request.');
    var pick = h('label', 'bmqa-pick');
    var pickTxt = h('span', null, '+ ADD FILES');
    var input = document.createElement('input');
    input.type = 'file'; input.multiple = true; input.accept = ACCEPT;
    input.setAttribute('aria-label', 'Upload artwork or reference images (optional)');
    pick.appendChild(pickTxt); pick.appendChild(input);
    var list = h('div', 'bmqa-list'); list.hidden = true;
    var msg = h('p', 'bmqa-msg'); msg.hidden = true;
    box.appendChild(lbl); box.appendChild(sub); box.appendChild(sub2);
    box.appendChild(pick); box.appendChild(list); box.appendChild(msg);
    q.listEl = list; q.msgEl = msg;
    input.addEventListener('change', function () {
      if (input.files && input.files.length) addFiles(q, input.files);
      input.value = '';
    });
    if (beforeEl) container.insertBefore(box, beforeEl);
    else container.appendChild(box);
    queues.push(q);
    q.box = box;
    return q;
  }

  /* Upload every pending file in q (sequential). progress(text) updates the
     caller's button; done(ok, errText) — ok=false leaves the form intact with
     the failed file marked so the customer can remove it or retry. */
  function uploadAll(q, progress, done) {
    if (!q || !q.items.length) { done(true); return; }
    var i = 0;
    (function next() {
      while (i < q.items.length && q.items[i].status === 'done') i++;
      if (i >= q.items.length) { renderList(q); done(true); return; }
      var it = q.items[i];
      if (progress) progress('Uploading artwork ' + (i + 1) + ' of ' + q.items.length + '…');
      renderList(q);
      uploadOne(it, function (ok) {
        renderList(q);
        if (!ok) { done(false, '"' + it.name + '" could not upload (' + (it.err || 'error') + '). Remove it or try again — your details are still filled in.'); return; }
        i++; next();
      });
    })();
  }

  function listOf(q) {
    if (!q) return [];
    return q.items.filter(function (it) { return it.status === 'done' && it.url; })
      .map(function (it) { return { url: it.url, name: it.name }; });
  }

  /* styles — neutral, inherit each host's typography */
  var css = document.createElement('style');
  css.textContent =
    '.bmqa{margin:18px 0 4px;padding:14px 16px;border:1px dashed rgba(127,150,180,.55);border-radius:12px}' +
    '.bmqa-lbl{font-weight:800;font-size:.8rem;letter-spacing:.1em;text-transform:uppercase;margin-bottom:8px}' +
    '.bmqa-sub{font-size:.88rem;line-height:1.5;margin:0 0 4px;opacity:.85}' +
    '.bmqa-sub2{font-size:.78rem;line-height:1.5;margin:0 0 10px;opacity:.65}' +
    '.bmqa-pick{display:inline-flex;align-items:center;position:relative;border:1px solid rgba(127,150,180,.6);border-radius:10px;padding:10px 18px;font-weight:800;font-size:.82rem;letter-spacing:.06em;cursor:pointer}' +
    '.bmqa-pick:hover{border-color:currentColor}' +
    '.bmqa-pick input{position:absolute;inset:0;opacity:0;cursor:pointer;width:100%;height:100%}' +
    '.bmqa-list{margin-top:10px;display:flex;flex-direction:column;gap:6px}' +
    '.bmqa-file{display:flex;align-items:center;gap:10px;font-size:.84rem;padding:7px 10px;border:1px solid rgba(127,150,180,.35);border-radius:8px}' +
    '.bmqa-name{flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;min-width:0}' +
    '.bmqa-st{font-size:.74rem;opacity:.75;white-space:nowrap}' +
    '.bmqa-st.done{color:#3fbf7f;opacity:1}.bmqa-st.error{color:#ff8f98;opacity:1}' +
    '.bmqa-rm{background:none;border:none;cursor:pointer;color:inherit;opacity:.65;font-size:.76rem;text-decoration:underline;padding:4px}' +
    '.bmqa-rm:hover{opacity:1}' +
    '.bmqa-msg{font-size:.82rem;margin:8px 0 0}.bmqa-msg.err{color:#ff8f98}';
  document.head.appendChild(css);

  var api = {
    mount: mount,
    uploadAll: uploadAll,
    list: listOf,
    csq: null /* the auto-mounted Custom Size Quote widget, when present */
  };

  function boot() {
    /* Auto-mount into the shared Custom Size Quote modal (all design stations
       use the same ids). Placed just above the honeypot/error/submit area. */
    var csqForm = document.getElementById('csqForm');
    if (csqForm) {
      var anchor = document.getElementById('csqErr') || document.getElementById('csqSend');
      api.csq = mount(csqForm, anchor);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.bmQuoteArt = api;
})();
